import React, { Component } from 'react'

// import seemore_box from "../../assets/images/seemore-rec.png"
import grey_box from "../../assets/images/grey-box.png"

class Expendition extends Component {
    render() {
        return (
            <>
                <div className="expendition-bg"></div>
                {/* <img src={seemore_box} className="expendition-img" alt="green background" /> */}
                <div className="expendition-green"></div>
                <div className="expendition-rec">
                    <h1 className="main-color expendition-text">EXPEDITONS ? LET’S GO!</h1>
                    <div className="expendition-card">
                        <p>
                        Getting it right requires that you trust your future with experts, everyday.
                            <br /><br /> Our goal as a forex group merging technology with our dealings in the financial market and the global world economy is promoting it’s realities and how it can be utilized in creating financial freedom & wealth for anyone and everyone.
                        </p>
                        <div className="expendition-card-img">
                            <img src={grey_box} />
                        </div>
                        <h4>Want to be part of our community? <span>Join us</span></h4>
                    </div>
                </div>
            </>
        )
    }
}

export default Expendition;